module.exports = __webpack_public_path__ + "media/images/front/icons/check-circle-2df7aeff01024b2fc6728d0e5a873cf4.svg";